// src/main.jsx
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom'
import App from './App'
import LoginPage from './screen/LoginScreen'
import ContactScreen from './screen/ContactScreen'
import './index.css'
import FaqScreen from './screen/FaqScreen'
import InscriptionScreen from './screen/InscriptionScreen'
import EvenementScreen from './screen/EvenementScreen'
import TutorielScreen from './screen/TutorielScreen'
import ProcedureScreen from './screen/ProcedureScreen'
import FormIn from './screen/FormIn'
import FormOut from './screen/FormOut'
import ProfileScreen from './screen/ProfileScreen'
import AproScreen from './screen/ApropoScreen'
import Dashboard from './screen/DashoboardScreen'
import useGlobale from './components/global'
import MesVoyages from './screen/dashboardcomponent/MesVoyagesPages'
import Documents from './screen/dashboardcomponent/DocumenetPage'
import DashboardAdmin from './screen/DashboardAdmin'
import VoyageursAeriens from './screen/VoyageAerien'
import VoyageurTerrestre from './screen/VoyageTerrestre'
import Compte from './screen/ComptePage'
import InformationsVoyageur from './screen/InformationVoyageurPage'
import Messagerie from './screen/Messagerie'


// Composant pour protéger les routes
const PrivateRoute = ({ element: Component }) => {
  const { authenticated } = useGlobale();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticated) {
      navigate('/login', { 
        replace: true,
        state: { from: window.location.pathname }
      });
    }
  }, [authenticated, navigate]);

  return authenticated ? Component : null;
};

// Composant principal qui wrappe l'application
const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Routes publiques */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/contact" element={<ContactScreen />} />
        <Route path="/faq" element={<FaqScreen />} />
        <Route path="/inscription" element={<InscriptionScreen/>} />
        <Route path="/evenement" element={<EvenementScreen/>} />
        <Route path="/tutoriels" element={<TutorielScreen/>} />
        <Route path="/procedure" element={<ProcedureScreen/>} />
        <Route path="/venir_au_niger" element={<FormIn/>} />
        <Route path="/sortir_du_niger" element={<FormOut/>} />
        <Route path="/a-propos" element={<AproScreen/>} />
        <Route path="/" element={<App />} />


        {/* Routes protégées */}
        <Route path="/profile" element={<PrivateRoute element={<ProfileScreen/>} />} />
        <Route path="/dashboard" element={<PrivateRoute element={<Dashboard/>} />} />
        <Route path="/mes-voyages" element={<PrivateRoute element={<MesVoyages/>} />} />
        <Route path="/mes-docuements" element={<PrivateRoute element={<Documents/>} />} />
        <Route path="/admin" element={<PrivateRoute element={<DashboardAdmin/>} />} />
        <Route path="/voyageurs-aeriens" element={<PrivateRoute element={<VoyageursAeriens/>} />} />
        <Route path="/voyageurs-terrestres" element={<PrivateRoute element={<VoyageurTerrestre/>} />} />
        <Route path="/gestion-de-comptes" element={<PrivateRoute element={<Compte/>} />} />
        <Route path="/informations-voyaeurs" element={<PrivateRoute element={<InformationsVoyageur/>} />} />
        <Route path="/messagerie" element={<PrivateRoute element={<Messagerie/>} />} />
      </Routes>
    </BrowserRouter>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);